import { BaseBlock } from "./BaseBlock";

import type { StateStore } from "../app/state/StateStore";

import type {
    CompletedLesson
} from "../app/state/AppState";

export class LessonBlock extends BaseBlock {

    private readonly lesson: CompletedLesson;

    private readonly store: StateStore;

    private root!: HTMLElement;

    constructor(
            lesson: CompletedLesson,
            store: StateStore,
            private readonly openKrok: (
                krokId: string
            ) => void
        ) {

            super();

            this.lesson = lesson;
            this.store = store;

        }

    public override mount(): void {

        this.root =
            this.buildRoot();

    }

    public override update(): void {

        const newRoot =
            this.buildRoot();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    public override unmount(): void {
    }

    public getRoot(): HTMLElement {

        return this.root;

    }

    // =========================
    // BUILD
    // =========================

    private buildRoot(): HTMLElement {

        const root =
            document.createElement("div");

        root.className =
            "lesson-block";

        const header =
            document.createElement("div");

        header.className =
            "lesson-header";

        const toggle =
            document.createElement("button");

        toggle.className =
            "lesson-toggle";

        const lessonId =
            this.lesson.lesson_id;

        toggle.addEventListener(
            "click",
            () => {

                this.store.update(prev => {

                    const isOpen =
                        prev.expandedLessons[
                            lessonId
                        ];

                    return {

                        ...prev,

                        expandedLessons: {

                            ...prev.expandedLessons,

                            [lessonId]:
                                !isOpen

                        }

                    };

                });

            }
        );

        const isOpen =
            this.store.getState()
                .expandedLessons[
                    lessonId
                ];

        toggle.textContent =
            isOpen ? "−" : "+";

        const title =
            document.createElement("span");

        title.className =
            "lesson-title";

        title.textContent =
            this.lesson.lesson_title;

        header.appendChild(
            toggle
        );

        header.appendChild(
            title
        );

        root.appendChild(
            header
        );

        // =========================
        // KROKS
        // =========================

        if (isOpen) {

            for (const krok of this.lesson.kroks) {

                if (krok.krok_id) {

                    const btn =
                        document.createElement("button");

                    btn.className =
                        "krok-btn";

                    if (
                        krok.krok_title.startsWith(
                            "Поточний/Наступний."
                        )
                    ) {

                        btn.classList.add(
                            "krok-current"
                        );

                    }

                    btn.textContent =
                        krok.krok_title;

                    btn.addEventListener(
                        "click",
                        () => {

                            this.openKrok(
                                krok.krok_id
                            );

                        }
                    );

                    root.appendChild(
                        btn
                    );

                } else {

                    const placeholder =
                        document.createElement("div");

                    placeholder.className =
                        "krok-placeholder";

                    placeholder.textContent =
                        krok.krok_title;

                    root.appendChild(
                        placeholder
                    );

                }

            }

        }

        return root;

    }

}